import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import resourcesServices from '../services/resourcesServices';
import TextControl from './customizedInputs/TextControl';
import TextAreaControl from './customizedInputs/TextAreaControl';
import SelectControl from './customizedInputs/SelectControl';
import { InputContext } from '../contexts/InputContext';
import BotonVolver from './BotonVolver';
import { errorMessage } from '../errorHandler';
import AsyncSelect from 'react-select/async';

const SorteoForm = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [authInformation, setAuthInformation, checkSignIn] = useContext(InputContext)

  const [sorteo, setSorteo] = useState({});
  const [esNuevo, setEsNuevo] = useState(true);
  const [estados, setEstados] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setEsNuevo( id === undefined )
    if(id){
      fetchSorteo(id)
    } else {
      nuevoSorteo()
    }
  }, [id]);


  const fetchSorteo = async (id) => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('sorteos', id);
      setEstados(data.estados);

      setSorteo(data);
    } catch (error) {
      errorMessage(error)
    }
  };

  const nuevoSorteo = async (id) => {
    try {
      const data = await resourcesServices.nuevoResource('sorteos');
      setEstados(data.estados);
      setSorteo(data);
    } catch (error) {
      errorMessage(error)
    }
  };

  const guardarSorteo = async () => {
    try {
      setSaving(true)
      let data;

      const copiaSorteo = {...sorteo};

      if(esNuevo){
        data = await resourcesServices.crearResource('sorteos', {sorteo: copiaSorteo}, true);
        alert("Sorteo creado")
        navigate(`/cl/sorteos`);
      } else {
        data = await resourcesServices.actualizarResource('sorteos', copiaSorteo.id, {sorteo: copiaSorteo}, true);
        setSorteo(data);
        alert("Datos actualizados")
      }

      setSaving(false)

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;

    if(name === 'es_publico'){

      setSorteo({...sorteo,
        [name]: !sorteo.es_publico
      })
    } else {
      setSorteo({...sorteo,
        [name]: value
      })
    }
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    guardarSorteo()
  }

  return (
    <div>
      {
        (authInformation.rol === "Organizador" || authInformation.rol === "Admin") && (
          <>
          <h3 className='mt-3'>Editar sorteo <BotonVolver /></h3>

          <div className="card">
            <div className="card-body px-0 pb-2 ms-3 me-3">
              <form onSubmit={handleFormSubmit}>
                <TextControl
                  value={sorteo.nombre}
                  name={'nombre'}
                  handleInput={handleInput}
                  />

                <TextAreaControl
                    value={sorteo.descripcion}
                    name={'descripcion'}
                    height={'150px'}
                    handleInput={handleInput}
                  />

                <div className='row'>
                  <div className='col'>
                    <TextControl
                      value={sorteo.f_inicio}
                      name={'f_inicio'}
                      type={"datetime-local"}
                      handleInput={handleInput}
                    />
                  </div>
                  <div className='col'>
                    <TextControl
                        value={sorteo.f_fin}
                        name={'f_fin'}
                        type={"datetime-local"}
                        handleInput={handleInput}
                      />
                  </div>
                  <div className='col'>
                    <div className="input-group-text mb-3">
                      <input className="form-check-input mt-0"
                        type="checkbox"
                        name="es_publico"
                        checked={sorteo.es_publico || 0}
                        onChange={handleInput}
                        value=""
                        />
                      <label className="ms-3 form-check-label" htmlFor="flexCheckDefault">
                        Es público
                      </label>
                    </div>
                  </div>
                </div>

                <div className='row mb-3'>
                  <div className='col'>
                    <SelectControl
                      value={sorteo.estado}
                      options={estados}
                      name={'estado'}
                      handleInput={handleInput}
                      label={'Seleccione el estado'}
                    />
                  </div>
                  <div className='col'>
                    <TextControl
                        value={sorteo.numero_ganadores}
                        name={'numero_ganadores'}
                        type={"number"}
                        handleInput={handleInput}
                      />
                  </div>
                </div>


                <button disabled={saving} className="btn btn-primary mt-3" type="submit">
                  {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                  <span role="status">Guardar</span>
                </button>
              </form>
            </div>
          </div>
          </>

        )
      }
    </div>
  );
};

export default SorteoForm;